import { render, staticRenderFns } from "./PointGiveaway.vue?vue&type=template&id=3392b906&scoped=true"
import script from "./PointGiveaway.vue?vue&type=script&lang=js"
export * from "./PointGiveaway.vue?vue&type=script&lang=js"
import style0 from "./PointGiveaway.vue?vue&type=style&index=0&id=3392b906&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392b906",
  null
  
)

export default component.exports